import { useEffect, useRef, useState } from 'react'

export function CGPercentageInput({ id, label, value, max, deviation = false, disabled, onChange }: {
  id: string; label: string; value: number; max: number; deviation?: boolean; disabled: boolean
  onChange: (value: number) => void
}) {
  const format = (fraction: number) => String(Number((fraction * 100).toFixed(4)))
  const [draft, setDraft] = useState(() => format(value))
  const [touched, setTouched] = useState(false)
  const input = useRef<HTMLInputElement>(null)
  const parsed = Number(draft)
  const valid = draft !== '' && Number.isFinite(parsed) && parsed >= 0 && parsed <= max * 100
  const message = valid || disabled ? '' : `Saisissez une valeur entre 0 et ${max * 100} %.`
  useEffect(() => { setDraft(format(value)) }, [value])
  useEffect(() => { input.current?.setCustomValidity(message) }, [message])
  return <div className="relative min-w-0">
    <div className="flex items-baseline justify-center gap-0.5">
      {deviation && <span aria-hidden="true" className="text-sm text-slate-500">±</span>}
      <input ref={input} id={id} type="number" inputMode="decimal" required min={0} max={max * 100} step="any" value={draft} disabled={disabled}
        aria-label={label} aria-invalid={!!message} aria-describedby={touched && message ? id + '-error' : undefined}
        onChange={event => {
          const next = event.target.value
          setDraft(next)
          if (next !== '' && Number.isFinite(Number(next)) && Number(next) >= 0 && Number(next) <= max * 100) onChange(Number(next) / 100)
        }}
        onBlur={() => setTouched(true)}
        onKeyDown={event => { if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); setDraft(format(value)); setTouched(false) } }}
        className="w-[76px] min-w-0 rounded-md border border-transparent bg-transparent px-1 py-0.5 text-right text-[22px] font-semibold leading-7 tabular-nums text-slate-900 outline-none hover:border-orange-200 focus:border-orange-400 focus:ring-1 focus:ring-orange-400 disabled:opacity-100 dark:text-white" />
      <span aria-hidden="true" className="text-xs text-slate-400">%</span>
    </div>
    {touched && message && <p id={id + '-error'} role="alert" className="text-[10px] leading-3 text-red-600">{message}</p>}
  </div>
}
